import { RespuestaLecturaError } from './Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from './SQL';
import { TratamientoDeParametroParaURI } from './Varios';

export const function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeCliente = async (IdCliente) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeCliente"

    try {
        const resulData = await llamadaAPI_GET("TODOS_AsistenciaEnLinea_Mensajes/ListarDeCliente/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdCliente);

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeProveedor = async (IdProveedor) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_ListarDeProveedor"

    try {
        const resulData = await llamadaAPI_GET("TODOS_AsistenciaEnLinea_Mensajes/ListarDeProveedor/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdProveedor);

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_ListarDePersona = async (IdPersona) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_ListarDePersona"

    try {
        const resulData = await llamadaAPI_GET("TODOS_AsistenciaEnLinea_Mensajes/ListarDePersona/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPersona);

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_MarcarLeido = async (IdMensaje) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_MarcarLeido"

    try {
        const resulData = await llamadaAPI_PUT("TODOS_AsistenciaEnLinea_Mensajes/MarcarLeido/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdMensaje);

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_Insertar = async (Mensaje) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_Insertar";

    try {
        const resultMensaje = await llamadaAPI_POST("TODOS_AsistenciaEnLinea_Mensajes/InsertarCompleto/", Mensaje);
        return resultMensaje;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_EnviarMensaje = async (Mensaje) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_EnviarMensaje";

    try {
        const resultMensaje = await llamadaAPI_POST("TODOS_AsistenciaEnLinea_Mensajes/EnviarMensaje/", Mensaje);
        return resultMensaje;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_EnviarRespuesta = async (Mensaje) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_EnviarRespuesta";

    try {
        const resultMensaje = await llamadaAPI_POST("TODOS_AsistenciaEnLinea_Mensajes/EnviarRespuesta/", Mensaje);
        return resultMensaje;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_TODOS_AsistenciaEnLinea_Mensajes_ListarChats = async (Canal) => {
    const NombreFuncion = "function_TODOS_AsistenciaEnLinea_Mensajes_ListarChats"

    try {
        const resulData = await llamadaAPI_GET("TODOS_AsistenciaEnLinea_Mensajes/ListarChats/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            Canal);

        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};